// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1p_FU","productName":"Table_productName__2adZ2"};